import { MenuItem } from "./MenuItem";
import { MenuInnerWithSub } from "./MenuInnerWithSub";
import { useAuth } from "../../../../../app/Context/auth";
import { useLanguage } from "../../../../../app/Context/language";

export function MenuInner() {
  const { usuario } = useAuth();
  const { t, isSpanish, isPortuguese } = useLanguage();

  return (
    <>
      {/* Menu em Português */}
      {isPortuguese && (
        <>
          <MenuInnerWithSub
            title="Listagem de notas"
            to="/notas"
            menuPlacement="bottom-start"
            menuTrigger="{default:'click', lg: 'hover'}"
          >
            <MenuItem to="/notas/nfe" title="NFe" hasBullet={true} />
            <MenuItem to="/notas/nfce" title="NFCe" hasBullet={true} />
            <MenuItem to="/notas/mdfe" title="MDFe" hasBullet={true} />
            <MenuItem to="/notas/cte" title="CTe" hasBullet={true} />
          </MenuInnerWithSub>
        </>
      )}

      {/* Menu em Espanhol */}
      {isSpanish && (
        <>
          <MenuInnerWithSub
            title="Facturación Electrónica"
            to="/notas"
            menuPlacement="bottom-start"
            menuTrigger="{default:'click', lg: 'hover'}"
          >
            <MenuItem to="/de/1" title="Factura" hasBullet={true} />
            <MenuItem to="/de/4" title="Autofactura" hasBullet={true} />
            <MenuItem to="/de/5" title="Nota de Crédito" hasBullet={true} />
            <MenuItem to="/de/6" title="Nota de Débito" hasBullet={true} />
            <MenuItem to="/de/7" title="Nota de Remisión" hasBullet={true} />
          </MenuInnerWithSub>
        </>
      )}

      <MenuItem title={t("menu.produtos")} to="/cadastros/produtos" />

      {isPortuguese && (
        <>
          <MenuItem
            title={t("menu.consulta_tributaria")}
            to="/consultas/tributacao"
          />{" "}
        </>
      )}

      {/* Arquivo Sped - apenas em Português e para sistema SCA */}
      {isPortuguese && usuario.sistema === "SCA" && (
        <MenuInnerWithSub
          title="Arquivo Sped"
          to="/sped"
          menuPlacement="bottom-start"
          menuTrigger="{default:'click', lg: 'hover'}"
        >
          <MenuItem to="/sped/fiscal" title="Sped Fiscal" hasBullet={true} />
        </MenuInnerWithSub>
      )}
    </>
  );
}
